import { Smile9UserSettings } from './../authenticate/auth-if';
import { CONSTANT } from '../../../constant/constant';

export namespace SCAN_TYPE_MSG {
  const getScanType = (scanTypes: any[]) => {
    if (scanTypes.length === 0) {
      return null;
    } else if (scanTypes.length >= 2) {
      return CONSTANT.SCAN_TYPE.MIX;
    } else {
      return scanTypes[0].value;
    }
  };

  /** カードスキャン待機時に画面表示されるメッセージ */
  export const PLEASE_SCAN_BY_YOUR_DEVICE = ((smile9UserSettings: Smile9UserSettings[]) => {
    const settings = smile9UserSettings.filter(s => s.item === CONSTANT.SMILE9_USER_SETTINGS.SCAN_TYPE);
    const scan_type = getScanType(settings);

    switch (scan_type) {
      case CONSTANT.SCAN_TYPE.MIX:
        return 'リーダーでスキャン<br>してください';
      case CONSTANT.SCAN_TYPE.IC_CARD:
        return 'リーダーにカードを<br>かざしてください';
      case CONSTANT.SCAN_TYPE.MAGNETIC_CARD:
        return 'リーダーにカードを<br>通してください';
      case CONSTANT.SCAN_TYPE.QR_CODE:
        return 'リーダーにQRコードを<br>かざしてください';
      // スキャン媒体情報のDB保持を実装するまでscan_type = nullで実装。
      case null:
        return 'リーダーにカードを<br>かざしてください';
    }
  });

  /** カードスキャン待機時に画面表示される画像 */
  export const SCAN_DEVICE_IMAGE = ((smile9UserSettings: Smile9UserSettings[]) => {
    const settings = smile9UserSettings.filter(s => s.item === CONSTANT.SMILE9_USER_SETTINGS.SCAN_TYPE);
    const scan_type = getScanType(settings);

    switch (scan_type) {
      case CONSTANT.SCAN_TYPE.MIX:
        return 'icon_touch_card.png';
      case CONSTANT.SCAN_TYPE.IC_CARD:
        return 'icon_touch_card.png';
      case CONSTANT.SCAN_TYPE.MAGNETIC_CARD:
        return 'icon_scan_magnetic_card.png';
      case CONSTANT.SCAN_TYPE.QR_CODE:
        return 'icon_scan_qr_code.png';
      // スキャン媒体情報のDB保持を実装するまでscan_type = nullで実装。
      case null:
        return 'icon_touch_card.png';
    }
  });

  /** スキャン対象物の画面上での呼称 */
  export const REGISTER_SCAN_ID = ((smile9UserSettings: Smile9UserSettings[]) => {
    const settings = smile9UserSettings.filter(s => s.item === CONSTANT.SMILE9_USER_SETTINGS.SCAN_TYPE);
    const scan_type = getScanType(settings);

    switch (scan_type) {
      case CONSTANT.SCAN_TYPE.MIX:
        return 'Smile9ID';
      case CONSTANT.SCAN_TYPE.IC_CARD:
        return 'フェリカ';
      case CONSTANT.SCAN_TYPE.MAGNETIC_CARD:
        return '磁気カード';
      case CONSTANT.SCAN_TYPE.QR_CODE:
        return 'QRコード';
      // スキャン媒体情報のDB保持を実装するまでscan_type = nullで実装。
      case null:
        return 'Smile9ID';
    }
  });

  /** 「カードスキャン」ボタンの呼称 */
  export const SCAN_BUTTON_LABEL = ((smile9UserSettings: Smile9UserSettings[]) => {
    const settings = smile9UserSettings.filter(s => s.item === CONSTANT.SMILE9_USER_SETTINGS.SCAN_TYPE);
    const scan_type = getScanType(settings);

    switch (scan_type) {
      case CONSTANT.SCAN_TYPE.MIX:
        return 'スキャン';
      case CONSTANT.SCAN_TYPE.IC_CARD:
        return 'カード\nスキャン';
      case CONSTANT.SCAN_TYPE.MAGNETIC_CARD:
        return 'カード\nスキャン';
      case CONSTANT.SCAN_TYPE.QR_CODE:
        return 'QR\nスキャン';
      // スキャン媒体情報のDB保持を実装するまでscan_type = nullで実装。
      case null:
        return 'カード\nスキャン';
    }
  });
}
